<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="$t('Tool.Setting')"
    width="650px"
    :close-on-click-modal="false"
  >
    <el-tabs v-model="activeTabName" type="card">
      <el-tab-pane :lazy="true" :label="$t('SystemMaintenance.ApplicationSettings')" name="applicationSettings">
        <el-form :disabled="!isEdit" label-width="120px" label-position="right" style="margin-top: 20px">
          <el-form-item>
            <span slot="label" class="title">{{ $t('SystemMaintenance.DropdownBoxValueDisplay') }}</span>
            <el-checkbox v-model="form.recentlyUsedDropdownData" style="margin-top:5px">{{ $t('SystemMaintenance.DisplayRecentlyUsed50Values') }}</el-checkbox>
          </el-form-item>
          <el-form-item>
            <span slot="label">{{ $t('SystemMaintenance.DisplayOrderLogic') }}</span>
            <span style="line-height: 28px;color: black;">{{ $t('SystemMaintenance.TheFirstValueTheSequentially') }}</span>
          </el-form-item>
        </el-form>
      </el-tab-pane>
    </el-tabs>
    <span slot="footer">
      <el-button type="primary" @click="okHandler">{{ $t('Message.Confirm') }}</el-button>
      <el-button @click="innerVisible=false">{{ $t('Message.Cancel') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'UserElementSetDialog',
  props: {
    visible: { type: Boolean, required: true },
    element: { type: Object, required: true },
    isEdit: { type: Boolean, default: true }
  },
  data() {
    return {
      innerVisible: false,
      activeTabName: 'applicationSettings',
      form: { recentlyUsedDropdownData: false }
    }
  },
  watch: {
    visible: {
      immediate: true,
      handler(newVal) {
        this.innerVisible = newVal
        if (newVal) {
          if (this.element.userCustomContent) {
            this.form = JSON.parse(this.element.userCustomContent)
          }
        }
      }
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
      if (!newVal) {
        this.form = { recentlyUsedDropdownData: false }
      }
    }
  },
  methods: {
    okHandler() {
      if (!this.isEdit) {
        this.innerVisible = false
        return
      }
      this.element.userCustomContent = JSON.stringify(this.form)
      this.innerVisible = false
    }
  }
}
</script>
